import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import $ from 'jquery'
import ScrollToTop from "react-scroll-to-top";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';



export default function HeaderTwo() {
 const path=useLocation();
  
  
  useEffect(()=>{
    //SubMenu Dropdown Toggle
      if ($('.menu-area li.menu-item-has-children ul').length) {
        $('.menu-area .navigation li.menu-item-has-children').append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');

      }

      //Mobile Nav Hide Show
      if ($('.mobile-menu').length) {

        var mobileMenuContent = $('.menu-area .push-menu').html();
        $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);

        //Dropdown Button
        $('.mobile-menu li.menu-item-has-children .dropdown-btn').on('click', function () {
          $(this).toggleClass('open');
          $(this).prev('ul').slideToggle(500);
        });


        $('.menu-backdrop, .mobile-menu .close-btn').click (()=>{
          $('body').removeClass('mobile-menu-visible');
        })


        //Menu Toggle Btn
        $('.mobile-nav-toggler').on('click', function () {
          $('body').addClass('mobile-menu-visible');
        });
      }
      

  },[]);

  useEffect(()=>{
    
    $(window).on('scroll', function () {
      var scroll = $(window).scrollTop();
      if (scroll < 245) {
        $("#sticky-header").removeClass("sticky-menu");
        $('.scroll-to-target').removeClass('open');
    
      } else {
        $("#sticky-header").addClass("sticky-menu");
        $('.scroll-to-target').addClass('open');
      }
    });
    
  },[])


  
  return (
	 <header> 
     <ScrollToTop smooth top="500" color="#000"/>
          <div id="sticky-header" className="transparent-header menu-area">
            <div className="container-fluid s-container-full-padding">
              <div className="row">
                <div className="col-12 md-flex justify-content-between align-items-center">
                  <div className="main-menu  menu-style-two">
                    <nav>
                      <div className="logo">
                        <Link to="/"><img src="/assets/img/logo/logo.png" alt="Logo" /></Link>
                      </div>
                      <div className="navbar-wrap push-menu d-none d-lg-flex">
                        <ul className="navigation">
                          <li className={` ${path.pathname=="/"?"show":""}`}><Link to="/">Home</Link>
                          </li>
                          <li className={`menu-item-has-children ${(path.pathname=="/web-games" || path.pathname=="/downloadable-games")?"show":""}`}><Link to="/web-games">Our Games</Link>
                            <ul className="submenu">
                              <li><Link to="/web-games">Web Games</Link></li>
                              <li><Link to="/downloadable-games">Downloadable Games</Link></li>
                            </ul>
                          </li>
                           <li className={`menu-item-has-children ${(path.pathname=="/business-model-liveplay" || path.pathname=="/business-mudgames" || path.pathname=="/business-gamesguru")?"show":""}`}><Link to="/business-model-liveplay">Business Model</Link>
                            <ul className="submenu">      
                              <li><Link to="/business-model-liveplay">Liveplay</Link></li>
                              <li><Link to="/business-mudgames">Mudgames</Link></li>
                              <li><Link to="/business-gamesguru">Gamesguru</Link></li>
                            </ul>
                          </li>
                          <li className={` ${path.pathname=="/menu-item-has-children"?"show":""}`} ><Link to="/technology">Technology</Link></li>
                          <li  className={` ${path.pathname=="/blogs"?"show":""}`} ><Link to="/blogs">News & Updates</Link></li>
                          <li  className={`${path.pathname=="/contact"?"show":""}`} ><Link to="/contact">contact</Link></li>
                        </ul>
                      </div>
                    </nav>
                  </div>
                <div className="mobile-nav-toggler two"><i className="fas fa-bars" /></div>
                
                 <div className="mobile-menu">
                  <nav className="menu-box">
                    <div className="close-btn"><i className="fas fa-times" /></div>
                    <div className="nav-logo">
                      <Link to="/"><img src="assets/img/logo/logo.png" alt="" title='true' /></Link>
                    </div>
                    <div className="menu-outer">
                  
                    </div>
                    <div className="social-links">
                      <ul className="clearfix d-flex jusify-content-start">
                        <li><a  target='_blank' rel="noreferrer" href="https://www.linkedin.com/company/obigin-media-labs/"><span className="fab fa-linkedin-in" /></a></li>
                       
                      </ul>
                    </div>
                  </nav>
                </div>
                <div className="menu-backdrop" />
              </div>
              </div>
            </div>
          </div>
        </header>
  )
}
